<template>
  <v-list>
    <v-list-group v-for="(category, i) in categories" :key="i" :value="category.active">
      <v-list-tile slot="activator" prepend-icon>
        <v-list-tile-content>
          <v-list-tile-title>
            {{ category.name }}
            <span v-if="category.translation">({{ category.translation }})</span>
            <v-icon v-if="!!category.soups" class="pl-2">mdi-bowl</v-icon>
            <v-icon v-else class="pl-2">restaurant</v-icon>
          </v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <category-edit-button
            :soups="category.soups"
            :category-name="category.name"
            :category-translation="category.translation"
            @update="(v) => { onCategoryEdit(category, v) }"
            @deleteCategory="$emit('deleteCategory', category)"
          />
        </v-list-tile-action>
      </v-list-tile>
      <selections
        ref="selections"
        :category="category"
        class="pr-3 pl-2"
        @deleteSelection="selection => deleteSelection(category, selection)"
        @onEnter="addSingleSelection(category)"
      />
      <v-speed-dial
        v-if="$vuetify.breakpoint.mdAndUp"
        class="min-content"
        style="display: inline-block"
        open-on-hover
        direction="right"
        transition="slide-y-reverse-transition"
      >
        <v-btn
          slot="activator"
          dark
          small
          color="primary"
          class="mb-3"
          @click="addSingleSelection(category)"
        >
          <v-icon left>add</v-icon>
          <span v-t="'editingContainer.dish'" />
        </v-btn>
      </v-speed-dial>
      <template v-else class="min-content">
        <v-btn
          dark
          small
          color="primary"
          class="mb-3"
          @click="addSingleSelection(category)"
        >
          <v-icon left>add</v-icon>
          <span v-t="'editingContainer.dish'" />
        </v-btn>
      </template>
    </v-list-group>
  </v-list>
</template>

<script>
import Selections from './selections/Selections.vue';
import CategoryEditButton from './category-edit-button/CategoryEditButton.vue';

export default {
  name: 'DishCategories',
  components: {
    selections: Selections,
    'category-edit-button': CategoryEditButton,
  },
  props: {
    categories: {
      type: Array,
      required: true,
    },
  },
  methods: {
    validate() {
      const results = this.$refs.selections
        .map(s => ({
          valid: s.validate(),
          tile: s.$parent,
          category: s.category,
        }));

      const invalidValue = results.find(r => !r.valid);
      if (invalidValue && !invalidValue.tile.isActive) {
        invalidValue.tile.click();
      }

      return !invalidValue;
    },
    addSingleSelection(category) {
      category.selections.push({
        dishes: [{ name: '' }],
        maxCount: null,
        price: null,
        isSoup: category.soups,
      });
      const selectionsRef = this.$refs.selections;
      setTimeout(() => {
        selectionsRef.find(s => s.categoryName.startsWith(category.name)).focus(category.name);
      });
    },
    onCategoryEdit(category, data) {
      category.soups = data.soups; // eslint-disable-line no-param-reassign
      category.name = data.name; // eslint-disable-line no-param-reassign
      category.translation = data.translation; // eslint-disable-line no-param-reassign
    },
  },
};
</script>

<style scoped>
  .small-width-button {
    min-width: 40px;
  }
</style>
